import {
  SET_MOBILE_MENU_STATE,
  SET_CURRENT_PAGE_TITLE,
  GET_APP_STATISTICS,
} from '~/data/constants/general-constants';

const initialState = {
  type: null,
  navigation: {
    menu: false,
    title: '',
  },
  statistics: [],
};

/**
 * The General Reducer
 *
 * @param {any} [state=initialState]
 * @param {any} action
 * @returns
 */
function general(state = initialState, action) {
  switch (action.type) {
    case SET_MOBILE_MENU_STATE:
      return {
        ...state,
        navigation: Object.assign({}, initialState.navigation, {
          menu: action.menu,
        }),
      };
    case SET_CURRENT_PAGE_TITLE:
      return {
        ...state,
        navigation: Object.assign({}, initialState.navigation, {
          title: action.title,
        }),
      };
    case GET_APP_STATISTICS:
      return {
        ...state,
        statistics: action.statistics,
      };
    default:
      return state;
  }
}

export default general;



// WEBPACK FOOTER //
// ./src/redux/reducers/general-reducer.jsx